import { I18nComponente } from "@/types/gerais"

export const OCapacidadeValorListai18n: I18nComponente = {
  "pt-BR": {
    atributo: "atributo",
    adicionarCapacidade: "adicionar capacidade",
    capacidadeJaFoiAdicionada: "A capacidade já foi adicionada",
    duplicado: "Duplicado",
  },
  "es-CO": {
    atributo: "atributo",
    adicionarCapacidade: "agregar capacidad",
    capacidadeJaFoiAdicionada: "La capacidad ya ha sido agregada",
    duplicado: "Duplicado",
  },
}
